"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StiloFormButton = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ThemeProvider = require("../../ThemeProvider");

var _button = _interopRequireDefault(require("../../button"));

var _style = _interopRequireDefault(require("../style"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var StiloFormButton = function StiloFormButton(_ref) {
  var _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === void 0 ? 'default' : _ref$buttonType,
      classes = _ref.classes,
      id = _ref.id,
      active = _ref.active,
      disabled = _ref.disabled,
      value = _ref.value,
      name = _ref.name,
      handleChange = _ref.handleChange,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["buttonType", "classes", "id", "active", "disabled", "value", "name", "handleChange"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.FormBase, " stilo-form")
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({}, props, {
    active: active,
    disabled: disabled,
    id: id,
    "data-ctrl-name": id,
    name: name,
    onChange: handleChange,
    bsStyle: buttonType
  }), value));
};

exports.StiloFormButton = StiloFormButton;
StiloFormButton.propTypes = {
  buttonType: _propTypes["default"].oneOf(['success', 'danger', 'default', 'link']),
  label: _propTypes["default"].string,
  name: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  value: _propTypes["default"].node,
  id: _propTypes["default"].string,
  handleChange: _propTypes["default"].func,
  classes: _propTypes["default"].object,
  active: _propTypes["default"].any
};
var ThemedStiloFormButton = (0, _ThemeProvider.withStyles)(_style["default"])(StiloFormButton);
exports["default"] = ThemedStiloFormButton;
//# sourceMappingURL=actionButton.js.map